import React from 'react';
import { useTranslation } from 'react-i18next';
import BrandLoader from './BrandLoader';
import LoadFailure from './LoadFailure';
import './ContentState.scss';

export default function ContentState({ status, emptyKey, onRetry }) {
  const { t } = useTranslation('brand');
  return <div className="content-state" data-state={status}>
    {status === 'loading' ? <BrandLoader label={t('loading')} /> : status === 'error'
      ? <LoadFailure onRetry={onRetry} /> : <p role="status">{t(emptyKey)}</p>}
  </div>;
}
